import * as React from 'react'

function SvgAsset47(props) {
  return (
    <svg viewBox="0 0 220 220" {...props}>
      <g data-name="Layer 2">
        <path
          fillRule="evenodd"
          d="M192.5 0L110 82.5 27.5 0H0v27.5L82.5 110 0 192.5V220h27.5l82.5-82.5 82.5 82.5H220v-27.5L137.5 110 220 27.5V0h-27.5z"
          data-name="Layer 1"
        />
      </g>
    </svg>
  )
}

export default SvgAsset47
